import { Box, Button, Tooltip } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { sdfOperationInFlightState } from '~/state/atoms/structureSet/roiAtoms';
import {
    crossSectionApplyRequestState,
    crossSectionPreviewReadyState,
} from '~/state/atoms/toolsAtoms';

/**
 * The Cross-Section tool's Apply, on a row of its own under the tool's
 * options: it commits what the preview shows.
 */
export default function CrossSectionApplyButton() {
    const intl = useIntl();
    // Gated on the preview, not the drawn contours: the modifiers can clip the shape away.
    const previewReady = useRecoilValue(crossSectionPreviewReadyState);
    const isProcessing = useRecoilValue(sdfOperationInFlightState);
    const requestApply = useSetRecoilState(crossSectionApplyRequestState);

    return (
        <Box
            sx={{
                p: 1.5,
                borderTop: '1px solid',
                borderColor: 'divider',
            }}
        >
            <Tooltip
                title={intl.formatMessage({
                    id: 'crossSectionTool.apply.hint',
                })}
            >
                {/* A disabled Button fires no events, so the tooltip needs a wrapper. */}
                <Box component="span" sx={{ display: 'flex' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={!previewReady || isProcessing}
                        onClick={() => requestApply((count) => count + 1)}
                        data-testid="cross-section-apply"
                    >
                        <FormattedMessage id="crossSectionTool.apply" />
                    </Button>
                </Box>
            </Tooltip>
        </Box>
    );
}
